var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManualFix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73244 4C3.38663 3.4022 2.74028 3 2 3C0.895431 3 0 3.89543 0 5C0 6.10457 0.895431 7 2 7C2.74028 7 3.38663 6.5978 3.73244 6H7.30822C5.97058 7.28146 4.94632 9.04182 4.18836 10.8664C2.67673 14.5053 2 18.8885 2 22V23H4V22C4 19.1116 4.63907 14.9948 6.03534 11.6337C6.79038 9.8161 7.70718 8.34823 8.77519 7.367C9.50329 8.35731 10.6766 9 12 9C13.3234 9 14.4967 8.35731 15.2248 7.36701C16.2928 8.34824 17.2096 9.8161 17.9647 11.6337C19.3609 14.9948 20 19.1116 20 22V23H22V22C22 18.8885 21.3233 14.5053 19.8116 10.8664C19.0537 9.04182 18.0294 7.28146 16.6918 6H20.2676C20.6134 6.5978 21.2597 7 22 7C23.1046 7 24 6.10457 24 5C24 3.89543 23.1046 3 22 3C21.2597 3 20.6134 3.4022 20.2676 4H15.874C15.4299 2.27477 13.8638 1 12 1C10.1362 1 8.57006 2.27477 8.12602 4H3.73244ZM10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualFix);
export default __webpack_public_path__ + "static/media/manual-fix.fa025aab.svg";
export { ForwardRef as ReactComponent };